/* Constants — ported from Shopify Dawn theme. Contract for app blocks. */
window.ON_CHANGE_DEBOUNCE_TIMER = 300;
window.PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
